import { useEffect } from 'react';
import { useContent } from '../../../../hooks/use-server-content';
import serverSideService from '../../../../services/server-side-service/server-side-service';

export interface TermsAndConditionsModalProps {
    hide: boolean;
    acceptTerms: string;
    declineTerms: string;
    modalNote: string;
    label1: string;
    text1: string;
    label2: string;
    text2: string;
    label3: string;
    text3: string;
}
export const useTermsAndConditionsModalContent = (): TermsAndConditionsModalProps | null => {
    const [content, getValueByName] = useContent(
        'common',
        'terms-and-conditions'
    );
    const decodeHtml = (html: string) => {
        const txt = document.createElement('textarea');
        txt.innerHTML = html;
        return txt.value.replace(/<p></g, '<').replace(/><\/p>/g, '/>');
    };
    let contentFragment: any;

    const setContentFragmentText = (contentFragment: any) => {
        if (!serverSideService.isClientSide()) return;

        ['text1', 'text2', 'text3'].forEach(key => {
            if (contentFragment[key]) {
                contentFragment[key] = decodeHtml(contentFragment[key]);
            }
        });
    };

    if (content) {
        contentFragment = {};
        content.elements.forEach(element => {
            contentFragment[`${element.name}`] = getValueByName(
                `${element.name}`
            );
        });
        if (contentFragment.hide || !contentFragment.text1) {
            contentFragment = null;
        } else {
            setContentFragmentText(contentFragment);
        }
    }
    const onAnchorClick = (event: Event) => {
        const anchor = event.target as HTMLAnchorElement;
        if (
            anchor &&
            anchor.attributes.getNamedItem('href')?.value.startsWith('#')
        ) {
            event.preventDefault();
            document
                .getElementById(anchor.href.split('#')[1])
                ?.scrollIntoView();
        }
    };
    useEffect(() => {
        const modalAnchorTags = Array.from(
            document.querySelectorAll('div.modal-body a')
        );
        modalAnchorTags.forEach(anchorTag =>
            anchorTag.addEventListener('click', onAnchorClick, false)
        );
        return () => {
            modalAnchorTags.forEach(anchorTag =>
                anchorTag.removeEventListener('click', onAnchorClick, false)
            );
        };
    }, [onAnchorClick]);
    return contentFragment as TermsAndConditionsModalProps;
};
